import SkillCard from './SkillCard';

const skillGroups = [
  {
    title: "Languages",
    items: ["Java", "JavaScript", "TypeScript", "Python", "SQL"],
  },
  {
    title: "Computer Science",
    items: ["Data Structures & Algorithms", "OOP", "DBMS", "Operating Systems"],
  },
  {
    title: "Frontend",
    items: ["React.js", "Next.js", "Redux Toolkit", "Tailwind CSS", "HTML5", "CSS3"],
  },
  {
    title: "Backend",
    items: ["Node.js", "Express.js", "Spring Boot", "Hibernate/JPA", "RESTful APIs", "JWT Auth"],
  },
  {
    title: "Databases",
    items: ["PostgreSQL", "MongoDB", "MySQL", "Redis"],
  },
  {
    title: "Cloud & DevOps",
    items: ["AWS (EC2, Lambda, S3, RDS)", "Amplify", "ACM", "Bedrock", "Docker", "Git", "GitHub Actions"],
  },
  {
    title: "AI / ML",
    items: ["LLM Integrations", "Amazon Bedrock", "Amazon Nova", "Claude Haiku", "Prompt Engineering", "Tool Calling"],
  },
  {
    title: "Testing",
    items: ["JUnit", "Mockito", "Jest"],
  },
];

export default function Skills() {
  return (
    <section className="border-t border-surface-border px-5 py-14 sm:px-12 sm:py-20">
      <h2 className="text-3xl font-bold mb-2 sm:text-4xl sm:mb-3">
        <span className="text-gradient">Technical Skills</span>
      </h2>
      <p className="text-gray-400 mb-8 sm:mb-10 text-sm sm:text-base">Technologies and tools I work with</p>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6">
        {skillGroups.map((group) => (
          <SkillCard key={group.title} title={group.title} items={group.items} />
        ))}
      </div>
    </section>
  );
}
